import BaseService from './BaseService'
import { api } from '@/boot/axios'

class SchedulingService extends BaseService {
  constructor() {
    super('/scheduling')
  }

  async listAppointments(params = {}) {
    const res = await api.get(`${this.baseURL}/appointments`, { params })
    return res.data
  }

  async getAppointment(id) {
    const res = await api.get(`${this.baseURL}/appointments/${id}`)
    return res.data
  }

  async createAppointment(payload) {
    const res = await api.post(`${this.baseURL}/appointments`, payload)
    return res.data
  }

  async updateAppointment(id, payload) {
    const res = await api.put(`${this.baseURL}/appointments/${id}`, payload)
    return res.data
  }

  async patchAppointmentStatus(id, payload) {
    const res = await api.patch(`${this.baseURL}/appointments/${id}/status`, payload)
    return res.data
  }

  async deleteAppointment(id) {
    await api.delete(`${this.baseURL}/appointments/${id}`)
  }

  async listSlots(params) {
    const res = await api.get(`${this.baseURL}/slots`, { params })
    return res.data
  }

  async getSlotsCalendarSummary(params) {
    const res = await api.get(`${this.baseURL}/slots/calendar-summary`, { params })
    return res.data
  }

  async getSlotsByDate(params) {
    const res = await api.get(`${this.baseURL}/slots/by-date`, { params })
    return res.data
  }

  async listServices(params = {}) {
    const res = await api.get(`${this.baseURL}/services`, { params })
    return res.data
  }

  async getService(id) {
    const res = await api.get(`${this.baseURL}/services/${id}`)
    return res.data
  }

  async createService(payload) {
    const res = await api.post(`${this.baseURL}/services`, payload)
    return res.data
  }

  async updateService(id, payload) {
    const res = await api.put(`${this.baseURL}/services/${id}`, payload)
    return res.data
  }

  async deleteService(id) {
    await api.delete(`${this.baseURL}/services/${id}`)
  }

  async listStaff(params = {}) {
    const res = await api.get(`${this.baseURL}/staff`, { params })
    return res.data
  }

  async getStaff(id) {
    const res = await api.get(`${this.baseURL}/staff/${id}`)
    return res.data
  }

  async createStaff(payload) {
    const res = await api.post(`${this.baseURL}/staff`, payload)
    return res.data
  }

  async updateStaff(id, payload) {
    const res = await api.put(`${this.baseURL}/staff/${id}`, payload)
    return res.data
  }

  async deleteStaff(id) {
    await api.delete(`${this.baseURL}/staff/${id}`)
  }

  async syncStaffServices(staffId, serviceIds) {
    const res = await api.put(`${this.baseURL}/staff/${staffId}/services`, { service_ids: serviceIds })
    return res.data
  }

  async listRules(params) {
    const res = await api.get(`${this.baseURL}/availability/rules`, { params })
    return res.data
  }

  async createRule(payload) {
    const res = await api.post(`${this.baseURL}/availability/rules`, payload)
    return res.data
  }

  /**
   * Replace all weekly availability rules for a staff member (atomic server-side).
   * @param {number} staffId
   * @param {Array<{ day_of_week: number, start_time: string, end_time: string }>} rules
   */
  async syncWeeklyRules(staffId, rules) {
    const res = await api.post(`${this.baseURL}/availability/rules/sync`, {
      staff_id: staffId,
      rules
    })
    return res.data
  }

  async updateRule(id, payload) {
    const res = await api.put(`${this.baseURL}/availability/rules/${id}`, payload)
    return res.data
  }

  async deleteRule(id) {
    await api.delete(`${this.baseURL}/availability/rules/${id}`)
  }

  async listExceptions(params) {
    const res = await api.get(`${this.baseURL}/availability/exceptions`, { params })
    return res.data
  }

  async createException(payload) {
    const res = await api.post(`${this.baseURL}/availability/exceptions`, payload)
    return res.data
  }

  async updateException(id, payload) {
    const res = await api.put(`${this.baseURL}/availability/exceptions/${id}`, payload)
    return res.data
  }

  async deleteException(id) {
    await api.delete(`${this.baseURL}/availability/exceptions/${id}`)
  }
}

export const schedulingService = new SchedulingService()
